export enum TRAVEL_CARD_VARIANTS {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
  EXTRA_LARGE = "EXTRA_LARGE",
  CONDENSED = "CONDENSED",
}
